import { post } from './http'
import { getToken } from '@/utils/auth'
export default {
  // 登录
  login (params) {
    return post('/sign_in', params)
  },
  // 注册
  signUp (params) {
    return post('/sign_up', params)
  },
  // 忘记密码
  forgetPwd (params) {
    return post('/forget_pwd', params)
  },
  // 首页
  getIndex (params) {
    if (getToken()) {
      return post('/user/index', params)
    } else {
      return post('/index', params)
    }
  },
  // 通知列表
  getNoticeList (params) {
    return post('/notice_list', params)
  },
  // 通知详情
  getNoticeDetail (params) {
    return post('/notice_detail', params)
  },
  // 获取专业列表
  catList () {
    return post('/cat_list', {})
  },
  // 获取用户信息
  getUserInfo (params) {
    return post('/user/check_sessionToken', params)
  },
  // 修改用户信息
  ModifyUserInfo (params) {
    return post('/user/modify_info', params)
  },
  // 修改用户头像
  ModifyAvatar (params) {
    return post('/user/modify_avatar', params)
  },
  // 修改用户密码
  ModifyPwd (params) {
    return post('/user/modify_pwd', params)
  },
  // 获取考试信息
  getExamInfo (params) {
    return post('/user/exam_info', params)
  },
  // 获取考试-专业列表
  getExamList (params) {
    return post('/user/exam_cat_list', params)
  },
  // 获取考试-专业-课程列表
  getExamCourseList (params) {
    return post('/user/exam_cat_course_list', params)
  },
  // 确认报名
  confirmApply (params) {
    return post('/user/confirm_apply', params)
  },
  // 报名列表
  getApplyList (params) {
    return post('/user/apply_list', params)
  },
  // 上传缴费证明
  uploadPayCert (params) {
    return post('/user/upload_pay_cert', params)
  },
  // 查看原因
  showFailInfo (params) {
    return post('/user/show_fail_info', params)
  },
  // 查看准考证
  showAdmissionCard (params) {
    return post('/user/show_admission_card', params)
  },
  // 修改准考证号
  changeAdmissionCard (params) {
    return post('/user/change_admission_card_code', params)
  },
  // 获取七牛上传参数
  getUploadToken (params) {
    return post('/user/upload_token', params)
  },
  // 获取该学生已经报名的课程
  getSelCourse (params) {
    return post('/user/exam_cat_sel_course', params)
  },
  // 获取该学生已经报名的专业的准考证号
  // getAdmissionCardCode (params) {
  //   return post('/user/exam_cat_admission_card_code', params)
  // },
  // 校验准考证号是否唯一
  // checkUniqueAdmissionCardCode (params) {
  //   return post('/user/check_unique_admission_card_code', params)
  // },
  // 上传工作实习证明
  // uploadWorkCert (params) {
  //   return post('/user/upload_work_cert', params)
  // },
  // 获取註冊验证码
  getCheckCode (params) {
    return post('/get_check_code', params)
  },
  // 获取忘記密碼验证码
  getForgetCheckCode (params) {
    return post('/get_check_code_forget', params)
  },
  // 获取论文计划信息
  getPaperInfo (params) {
    return post('/user/paper/info', params)
  },
  // 上传论文
  confirmSubmit (params) {
    return post('/user/paper/confirm_submit', params)
  },
  // 获取论文列表
  getPaperList (params) {
    return post('/user/paper/list', params)
  },
  // 修改论文准考证号、专业
  modifyAdmissionCode (params) {
    return post('/user/paper/change_admission_card_code', params)
  },
  // 论文信息的编辑
  mofifyPaper (params) {
    return post('/user/paper/modify', params)
  },
  // 查看论文审核失败原因
  showPaperFailInfo (params) {
    return post('/user/paper/show_fail_info', params)
  },
  // 获取论文计划获取专业列表
  getPaperCatList (params) {
    return post('user/paper/paper_cat_list', params)
  },
  // 培训报名部分---------------------------
  // 获取结业时间
  getCertTime (params) {
    return post('/user/apply_plan/cert_time', params)
  },
  // 培训报名列表
  getApplyPlanApplyList (params) {
    return post('/user/apply_plan/apply_list', params)
  },
  // 培训报名列表
  getAllApplyList (params) {
    return post('/user/apply_plan/course_list', params)
  },
  // 培训修改准考证号
  changeApplyPlanAdmissionCard (params) {
    return post('/user/apply_plan/change_admission_card_code', params)
  },
  // 培训校验准考证号是否唯一
  // checkApplyPlanUniqueAdmissionCardCode (params) {
  //   return post('/user/apply_plan/check_unique_admission_card_code', params)
  // },
  // 培训确认报名
  confirmApplyPlanApply (params) {
    return post('/user/apply_plan/confirm_apply', params)
  },
  // 培训查看原因
  showApplyPlanFailInfo (params) {
    return post('/user/apply_plan/show_fail_info', params)
  },
  // 培训获取该学生已经报名的专业的准考证号
  // getApplyPlanAdmissionCardCode (params) {
  //   return post('/user/apply_plan/apply_plan_cat_admission_card_code', params)
  // },
  // 培训获取培训-专业-课程列表
  getApplyPlanCourseList (params) {
    return post('/user/apply_plan/apply_plan_cat_course_list', params)
  },
  // 培训获取培训-专业列表
  getApplyPlanList (params) {
    return post('/user/apply_plan/apply_plan_cat_list', params)
  },
  // 培训获取该学生已经报名的课程
  getApplyPlanSelCourse (params) {
    return post('/user/apply_plan/apply_plan_cat_sel_course', params)
  },
  // 培训获取培训信息
  getApplyPlanInfo (params) {
    return post('/user/apply_plan/apply_plan_info', params)
  },
  // 培训上传缴费证明
  uploadApplyPlanPayCert (params) {
    return post('/user/upload_pay_cert', params)
  },
  // 上传作业
  uploadHomeworkList (params) {
    return post('/user/apply_plan/upload_homework', params)
  },
  // 培训查看准考证
  showApplyPlanAdmissionCard (params) {
    return post('/user/apply_plan/show_admission_card', params)
  },
  // 公开查询结业证书（免登录）
  queryCompletionCert (params) {
    return post('/query_completion_cert', params)
  }
}



// WEBPACK FOOTER //
// ./src/service/api.js